module.exports = __webpack_public_path__ + "img/FLSH6.cf87a71f.svg";